import './styles.scss'
import React from 'react'
import { getStaticImage } from 'utils/statics'

const TextWithCopy = ({ value }) => (
  <div className='text-with-copy'>
    <p className='text-ellipsis'>{value}</p>
    <button
      type='button'
      onClick={() => navigator.clipboard.writeText(value)}
    >
      <figure>
        <img src={getStaticImage('/icons/orange-brand/icon-copy-primary.svg')} alt='Copy' />
      </figure>
    </button>
  </div>
)

export default TextWithCopy
